<template>
  <div :class="[`${getName}-layout auth-layout container`, addClass]">
    <div class="row clearfix">
      <div class="offset-lg-3 col-lg-6 offset-md-2 col-md-8">
        <div class="card">
          <div class="header">
            <h1>
              <span v-if="getName === 'login'" class="logo"></span>
              <router-link v-else to="/auth/login">
                <span class="logo"></span>
              </router-link>
            </h1>
            <p
              v-if="getName === 'login'"
              v-text="$t('common.t_smart_solution_desc')"
            ></p>
          </div>
          <div class="body">
            <slot name="body"></slot>
          </div>
          <div class="option">
            <div class="lang">
              <img src="@assets/images/icon-language.png" alt="Language" />
              <select v-model="language" @change="changeLanguage">
                <option value="ko">한국어</option>
                <option value="ja">日本語</option>
                <option value="en">English</option>
              </select>
            </div>
            <div class="link">
              <router-link
                v-if="getIsSignup"
                to="/auth/terms"
                class="signup"
                v-text="$t('common.b_signup')"
              ></router-link>
              <router-link
                v-if="getName !== 'login'"
                to="/auth/login"
                v-text="$t('login')"
              ></router-link>
              <router-link
                v-if="getName !== 'find-id'"
                to="/auth/find-id"
                v-text="$t('find_id')"
              ></router-link>
              <router-link
                v-if="getName !== 'find-password'"
                to="/auth/find-password"
                v-text="$t('find_pw')"
              ></router-link>
            </div>
          </div>
          <div class="footer">
            <h1 class="sm">
              <span class="logo"></span>
            </h1>
            <span>Copyright ISUNG Corp. All Rights Reserved</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Cookies from 'js-cookie';
import { Common } from '@src/common';

export default {
  name: 'authLayout',
  props: ['name', 'addClass'],
  computed: {
    getName() {
      return this.name ?? 'custom';
    },
    getIsSignup() {
      return _.indexOf(['signup', 'terms'], this.getName) < 0;
    },
  },
  data() {
    return {
      language: '',
    };
  },
  created() {
    this.language = Cookies.get(Common.STORAGE_LANG);
  },
  methods: {
    changeLanguage() {
      Cookies.set(Common.STORAGE_LANG, this.language);
      window.location.reload();
    },
  },
};
</script>

<style scoped lang="scss">
.auth-layout {
  .card {
    margin-top: 104px;
    margin-bottom: 72px;
  }

  .header {
    text-align: center;

    p {
      margin-top: 18px;
      font-size: 12px;
      color: $gray-48;
      text-align: center;
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 32px;

    h1 + span {
      margin-left: 24px;
      color: $gray-88;
    }
  }

  .body {
    margin-top: 66px;
    padding: 0 18px;
  }

  .option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;

    .lang {
      display: flex;
      align-items: center;
    }

    .lang select {
      width: 58px;
      height: auto;
      margin-left: 4px;
      padding-left: 4px;
      border: 0 none;
      background-color: transparent;
      background-position: right center;
    }

    .link {
      display: flex;
      align-items: center;
      margin-left: 24px;
      padding-bottom: 10px;
    }

    .link a {
      padding: 0 6px;
      font-size: 11px;
      color: $gray-88;
    }

    .link a + a {
      border-left: 1px solid $gray-e6;
    }

    .link a:last-child {
      padding-right: 0;
    }
  }
}

.login .card .body {
  margin-top: 60px;
  padding: 0;
  border: 1px solid $gray-e6;
  border-top: 0 none;
  background: $white;
}
</style>
